import { create } from "zustand";
import type { Plan } from "../types/domain.types";

interface PlanState {
  plans: Plan[];
  activePlan: Plan | null;
  isLoading: boolean;
  error: string | null;
  setPlans: (plans: Plan[]) => void;
  setActivePlan: (plan: Plan | null) => void;
  setLoading: (isLoading: boolean) => void;
  setError: (error: string | null) => void;
}

export const usePlanStore = create<PlanState>((set) => ({
  plans: [],
  activePlan: null,
  isLoading: false,
  error: null,
  setPlans: (plans) => set({ plans }),
  setActivePlan: (activePlan) => set({ activePlan }),
  setLoading: (isLoading) => set({ isLoading }),
  setError: (error) => set({ error }),
}));
